export default {
  categories: {
    id: 'menu_categories',
    defaultMessage: 'Categories',
  },
  see_all: {
    id: 'menu_see_all',
    defaultMessage: 'See all',
  },
}
